import { useCallback, useEffect, useRef, useState } from "react";
import { useChatSupport } from "../../../context/chat-support/chat-support.context";
import { ActiveChatHeader } from "../molecules/active-chat-header";
import styles from "./active-chat.module.css";
import { ActiveChatInput } from "../molecules/active-chat-input";
import {
  ChatSupportActiveChatContextType,
  ChatSupportActiveContext,
} from "../../../context/chat-support/chat-support-active-chat.context";
import { ActiveChatMessage, PendingMessage } from "../../../types/chat-support/chat-support.type";
import { ActiveChatPendingMessage } from "../molecules/active-chat-pending-msg";
import { ActiveChatMessagesContainer } from "./active-chat-messages-container";
import { ActiveChatOldMSGs } from "../atoms/active-chat-old-msgs";
import { NewMsgScrollHelper } from "../atoms/active-chat-new-msg-helper";
export const ActiveChat = () => {
  const [messages, setMessages] = useState<ActiveChatMessage[]>([]);
  const [pendingMsgs, setPendingMsgs] = useState<PendingMessage[]>([]);
  const [newRecivedMessagesCount, setNewRecivedMessagesCount] = useState(0);
  const [isOldMessages, setIsOldMessages] = useState(false);
  const msgsContainerBottomRef = useRef<HTMLDivElement>(null);
  const initialFechedRef = useRef<boolean | null>(null);
  const lastActiveChatDocId = useRef<string>("");
  const contextState: ChatSupportActiveChatContextType = {
    states: {
      messages: {
        messages,
        setMessages,
        limit: 30,
        newRecivedMessagesCount,
        setNewRecivedMessagesCount,
        msgsContainerRef: msgsContainerBottomRef,
        initialFechedRef,
      },
      pending: {
        pendingMsgs,
        setPendingMsgs,
      },
      isOldMessages: {
        isOldMessages,
        setIsOldMessages,
      },
    },
  };
  const {
    actions,
    states: {
      activeChatRoom: { activeChatRoom, setActiveChatRoom },
    },
  } = useChatSupport();

  const resetInitalState = useCallback(() => {
    if (lastActiveChatDocId.current === activeChatRoom.id) return; // normal rerended like update last message

    lastActiveChatDocId.current = activeChatRoom.id;
    setMessages([]);
    setPendingMsgs([]);
    setNewRecivedMessagesCount(0);
    setIsOldMessages(false);
    initialFechedRef.current = false;
  }, [lastActiveChatDocId, activeChatRoom]);

  useEffect(() => {
    if (messages.length && activeChatRoom) {
      const lastMessage = messages[0];
      setActiveChatRoom((old) => ({ ...old, lastMessage }));
    }
  }, [messages]);

  useEffect(() => {
    if (activeChatRoom.unreadCountSupport > 0) {
      actions.updateServerUnRead();
    }
    resetInitalState();
  }, [activeChatRoom, actions]);
  console.log(activeChatRoom);
  return (
    <ChatSupportActiveContext.Provider value={contextState}>
      <div className="flex flex-col h-full    w-full">
        <ActiveChatHeader />

        <div className={`${styles["chat-container"]} flex-1  t-flex flex-col relative `}>
          <div
            ref={msgsContainerBottomRef}
            className="  absolute left-0 top-0  p-1  flex  flex-col  gap-4 overflow-y-auto  h-full w-full"
          >
            {/* old message */}
            <ActiveChatOldMSGs />
            <ActiveChatMessagesContainer />
            {/* pending messages */}

            {pendingMsgs.map((message) =>
              // saving message promise take time and listner snapshot trigger reRender without promise resolve reRender happen twice
              message.tempId ? <ActiveChatPendingMessage key={message.tempId} message={message} /> : null
            )}
            <NewMsgScrollHelper />
          </div>
        </div>
        <div className="mt-auto flex  w-full">
          <ActiveChatInput />
        </div>
      </div>
    </ChatSupportActiveContext.Provider>
  );
};
